import { FunctionComponent, isValidElement } from 'react'
import { PaletteColor } from '../../style/colors'
import { Icon, IconName } from '../../components/Icon'
import { WithClassName } from '../../types/utils'
import { TOAST_TYPE_COLOR, ToastHandlerMessage, ToastType } from './ToastConfig'

export type ToastMessageProps = WithClassName & {
  type?: ToastType
  icon?: IconName
  message: ToastHandlerMessage
  iconFillColor?: PaletteColor[keyof PaletteColor]
}

/**
 * Should only be used when calling toast functions in useToast
 */
export const ToastMessage: FunctionComponent<ToastMessageProps> = ({ className, message, icon, type, iconFillColor }) => {
  const isSingleElement = isValidElement<any>(message) || typeof message === 'string'
  return (
    <div className={`${className} inline-flex flex-col gap-3 items-start py-4 px-5 font-roboto text-base leading-5.5`}>
      <span className="inline-flex gap-2 items-start">
        {icon && (
          <Icon
            name={icon}
            size={'md'}
            fill={iconFillColor ? iconFillColor : TOAST_TYPE_COLOR[type ?? 'neutral'].color}
            color={iconFillColor ? iconFillColor : TOAST_TYPE_COLOR[type ?? 'neutral'].color}
          />
        )}
        {isSingleElement ? <span>{message}</span> : <strong>{message?.title}</strong>}
      </span>
      {!isSingleElement && message?.body}
    </div>
  )
}
